// Initialize to default CAPTURE_AND_PROCESS_FRAME defaults

import { createSlice } from "@reduxjs/toolkit";

export const sdkOptionsSlice = createSlice({
  name: "sdkOptions",
  initialState: {
    value: {
      qualityPercent: 80,
      guidePaddingLevel: 1,
      hintFrequencyMS: 1200,
      hintMessageSize: 2,
      disableSmileDetection: false,
      videoContainerId: null,
      hintAriaLive: 2,
    },
  },
  reducers: {
    update: (state, action) => {
      state.value.qualityPercent = action.payload.qualityPercent;
      state.value.guidePaddingLevel = action.payload.guidePaddingLevel;
      state.value.hintFrequencyMS = action.payload.hintFrequencyMS;
      state.value.hintMessageSize = action.payload.hintMessageSize;
      state.value.disableSmileDetection = action.payload.disableSmileDetection;
      state.value.videoContainerId = action.payload.videoContainerId;
      state.value.hintAriaLive = action.payload.hintAriaLive;
    },
  },
});

export const { update } = sdkOptionsSlice.actions;

export default sdkOptionsSlice.reducer;
